import Immutable from 'seamless-immutable'
import Api from '../lib/api'

export const SET_DOCUMENTS_COLLECTION_VIEW = 'SET_DOCUMENTS_COLLECTION_VIEW'
export const SET_DOCUMENTS_COLLECTION_VIEWS = 'SET_DOCUMENTS_COLLECTION_VIEWS'
export const SET_DOCUMENT = 'SET_DOCUMENT'
export const UPDATE_DOCUMENT_COLLECTION_VIEW = 'UPDATE_DOCUMENT_COLLECTION_VIEW'
export const SET_DOCUMENTS_LOADING = 'SET_DOCUMENTS_LOADING'


export const loadDocumentCollectionViews = ({folderId, page, perPage, search, tags, sortBy, sortDirection})=>{
    return async (dispatch)=>{
        dispatch({
            type:SET_DOCUMENTS_LOADING,
            loading:true
        })
        let {documentCollectionViews, total} = await Api.getDocumentCollectionViews({folderId, page, perPage, search, tags, sortBy, sortDirection})
        dispatch({
            type:SET_DOCUMENTS_LOADING,
            loading:false
        })
        dispatch({
            type: SET_DOCUMENTS_COLLECTION_VIEWS,
            documentCollectionViews,
            documentCollectionViewsCount: total
        })
    }
}

export const loadDocumentCollectionView = ({documentCollectionViewId})=> {
    return async (dispatch) => {
       
        let [documentCollectionView, comments] = await Promise.all([
            Api.getDocumentCollectionView({documentCollectionViewId}),
            Api.getDocumentCollectionViewComments({documentCollectionViewId})
        ])
        if(!documentCollectionView) return
        documentCollectionView.comments = comments || []
        dispatch({
            type: SET_DOCUMENTS_COLLECTION_VIEW,
            documentCollectionView
        })
    }
}

export const updateDocumentCollectionViewVisible = ({documentCollectionView, visible})=>{
    return async (dispatch)=>{
        dispatch({
            type: UPDATE_DOCUMENT_COLLECTION_VIEW,
            documentCollectionView,
            data:{
                visible
            }
        })
        visible = await Api.updateDocumentCollectionViewVisible({documentCollectionViewId: documentCollectionView.id, visible})
    }
}

export const updateDocumentCollectionViewTag = ({documentCollectionView, tag})=>{
    
    return async (dispatch) =>{
        let tags = documentCollectionView.tags || []
        if(tags.indexOf(tag) > -1){
            tags = tags.filter((t)=>t !== tag)
        }else{
            tags = tags.concat([tag])
        }
      
        dispatch({
            type: UPDATE_DOCUMENT_COLLECTION_VIEW,
            documentCollectionView,
            data:{
                tags
            }
        })
        
        tags = await Api.updateDocumentCollectionViewTags({documentCollectionViewId: documentCollectionView.id, tags})

    }
}
export const createDocumentCollectionViewComment = ({documentCollectionView, text, documentId})=>{
    return async (dispatch)=>{
        let comment = await Api.createDocumentCollectionViewComment({documentCollectionViewId: documentCollectionView.id, text, documentId})
        let comments = documentCollectionView.comments.concat([comment])
        dispatch({
            type: UPDATE_DOCUMENT_COLLECTION_VIEW,
            documentCollectionView,
            data: {
                comments
            }
        })

    }
}
export const loadDocumentCollectionViewComments = ({documentCollectionView})=>{
    return async (dispatch)=>{
        let comments = await Api.getDocumentCollectionViewComments({documentCollectionViewId: documentCollectionView.id})
        dispatch({
            type: UPDATE_DOCUMENT_COLLECTION_VIEW,
            documentCollectionView,
            data:{
                comments
            }
        })
    }
}

export const removeDocumentCollectionViewComment = ({documentCollectionView, comment})=>{
    return async (dispatch)=>{
        let removed = await Api.updateDocumentCollectionViewComment({documentCollectionViewId: documentCollectionView.id, commentId: comment.id, status: 'archived'}) 
        console.log('removed', removed)
        let comments = documentCollectionView.comments.filter((c)=>{
            return c.id !== comment.id
        })
        dispatch({
            type: UPDATE_DOCUMENT_COLLECTION_VIEW,
            documentCollectionView,
            data: {
                comments
            }
        })
    }
}

export const loadDocument = ({documentId})=>{
    return async (dispatch, getState)=>{
        let state = getState()
        let document

        

        if(state.documents && state.documents.documentCollectionView){

            document = state.documents.documentCollectionView.documents.find((document)=>{
                return document.id + '' === documentId
            })
        }
        if(document && !document.description){
            dispatch({
                type: SET_DOCUMENT,
                document
            })
        }
        if(!document || (document && !document.description)){
            document = await Api.getDocument({documentId})
        }
        if(document){
            dispatch({
                type: SET_DOCUMENT,
                document
            })
        }
        return document
    }
}

const updateDocumentCollectionViewsInState = (state, action)=>{
    let {data, documentCollectionView} = action
    let documentCollectionViews = state.documentCollectionViews.map((view)=>{
        if(view.id === documentCollectionView.id){
            return Immutable.merge(view, data)
        }else{
            return view
        }
    })

    if(state.documentCollectionView && state.documentCollectionView.id === documentCollectionView.id){
        state = state.set('documentCollectionView', Immutable.merge(state.documentCollectionView, data))
    }

    return state.set('documentCollectionViews', documentCollectionViews)
}


const initialState = Immutable({users: []})

export const reducer = (state = initialState, action)=>{

    switch (action.type) {
    case SET_DOCUMENTS_LOADING:
        return state.set('loading', action.loading)
    case SET_DOCUMENTS_COLLECTION_VIEWS:
        return state.set('documentCollectionViews', action.documentCollectionViews).set('documentCollectionViewsCount', action.documentCollectionViewsCount)
    case SET_DOCUMENTS_COLLECTION_VIEW:
        return state.set('documentCollectionView', action.documentCollectionView)
    case SET_DOCUMENT:
        return state.set('document', action.document)
    case UPDATE_DOCUMENT_COLLECTION_VIEW:
        return updateDocumentCollectionViewsInState(state, action)
    default:
        return state
    }

}



// WEBPACK FOOTER //
// ./src/actions/documents.js